 <!-- Start Testimonial Area -->
 <div class="brook-testimonial-area ptb--165 ptb-md--80 ptb-sm--80 bg_image--51 slick-arrow-hover">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brook-section-title text-center mb--65">
                    <h3 class="heading heading-h3 text-white">Testimoniales</h3>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 pb--60">
                <div class="brook-element-carousel slick-arrow-center slick-dots-bottom" data-slick-options='{
                            "spaceBetween": 15, 
                            "slidesToShow": 3, 
                            "slidesToScroll": 1, 
                            "arrows": true, 
                            "infinite": true,
                            "dots": true,
                            "prevArrow": {"buttonClass": "slick-btn slick-prev", "iconClass": "fas fa-angle-left" },
                            "nextArrow": {"buttonClass": "slick-btn slick-next", "iconClass": "fas fa-angle-right" }
                        }'
                    data-slick-responsive='[
                            {"breakpoint":991, "settings": {"slidesToShow": 2}},
                            {"breakpoint":577, "settings": {"slidesToShow": 1}},
                            {"breakpoint":481, "settings": {"slidesToShow": 1}}
                        ]'>

                    <!-- Start Single Testimonial -->
                    <div class="testimonial testimonial_style--1">
                        <div class="content">
                            <p class="bk_pra">“Quiero que sepas que estoy muy pendiente y agradecida . He tenido cambios muy positivos.  Aún me falta ver que veo cuando observo. Un poco estresada pero mucho menos de lo que antes estaría, gracias a mi trabajo con mi curso me ha hecho bien. <span class="theme-color"></span></p>
                            <div class="testimonial-info">
                                <div class="post-thumbnail">
                                    <img src="assets/img/directorio/clint-1.jpg" alt="Nedda">
                                </div>
                                <div class="clint-info">
                                    <h6>Nedda</h6>
                                    <span> Playa del Carmen, Mexico</span>
                                </div>
                            </div>
                            <div class="testimonial-quote">
                                <span class="fa fa-quote-right"></span>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Testimonial -->

                    <!-- Start Single Testimonial -->
                    <div class="testimonial testimonial_style--1">
                        <div class="content">
                            <p class="bk_pra">“Fue muy bonito para mi muy agradable compartiendo con  mis padres y mis hijos pláticas y mucha tranquilidad, algo que antes no se encontraba de esa manera tan relajada,  observe muchos cambios en mi y sinceramente he observado y me he observado  una  manera más amorosa a los demás siendo más paciente y esa era una de las palabras que más resonaba en mi la amorosidad,la transformación,la expansión 🙏💜gracias, gracias, gracias Anita por tu acompañamiento por ser y estar 😘
El amor ya es en mi (3) la transformación ya es (3),la expansión ya es (3) gracias, gracias,gracias Anita ✨❣💜”</p>
                            <div class="testimonial-info">
                                <div class="post-thumbnail">
                                    <img src="assets/img/directorio/clint-1.jpg" alt="Susana Cruz">
                                </div>
                                <div class="clint-info">
                                    <h6>Susana Cruz</h6>
                                    <span>Tuxtla Gtz, Chiapas</span>
                                </div>
                            </div>
                            <div class="testimonial-quote">
                                <span class="fa fa-quote-right"></span>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Testimonial -->

                    <!-- Start Single Testimonial -->
                    <div class="testimonial testimonial_style--1">
                        <div class="content">
                            <p class="bk_pra">“Para mi este curso a significado mucho, ya que he podido observar otro tipo de actitudes, me he mirado, he mirado a otras personas desde una visión muy distinta, hoy estoy convencida que no es pose, es amor real, es tener la actitud de amor que prevalece sobre todo, es mirarme tal cual soy y no juzgarme, es reconocer mi propia aceptación, mi merecimiento y mi cariño.”</p>
                            <div class="testimonial-info">
                                <div class="post-thumbnail">
                                    <img src="assets/img/directorio/clint-1.jpg" alt="Alma">
                                </div>
                                <div class="clint-info">
                                    <h6>Alma</h6>
                                    <span>Ciudad del Carmen, Campeche</span>
                                </div>
                            </div>
                            <div class="testimonial-quote">
                                <span class="fa fa-quote-right"></span>
                            </div>
                        </div>
                    </div>
                    <!-- End Single Testimonial -->

                                         </div>
            </div>
        </div>
    </div>
</div>
<!-- End Testimonial Area -->
